/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function PolicyPage() {
  const styleBodyWorkshop = {
    padding: '20px 5px',
  };
  const styleSpan = {
    color: 'rgb(74, 74, 74)',
  };
  const styleStrong = {
    color: 'rgb(54, 54, 54)',
  };
  const styleATag = {
    color: 'rgb(50, 115, 220)',
  };

  return (
    <div style={styleBodyWorkshop}>
      <div>
        <p>
          <strong style={{ color: 'rgb(54, 54, 54)' }}>Privacy Policy</strong>
        </p>
        <p>
          <span style={styleSpan}>
            SkyEye Pacific built the Samoa Travel Tracer app on behalf of the
            Samoan Government. The App is based on the BlueTrace Open Source
            protocol developed and shared by the Government Digital Services of
            Singapore. This SERVICE is provided by SkyEye Pacific at no cost and
            is intended for use as is.
          </span>
        </p>
        <p>
          <span style={styleSpan}>
            This page is used to inform visitors regarding our policies with the
            collection, use, and disclosure of Personal Information if anyone
            decided to use our Service.
          </span>
        </p>
        <p>
          <span style={styleSpan}>
            If you choose to use our Service, then you agree to the collection
            and use of information in relation to this policy. The Personal
            Information that we collect is used for providing the Service. We
            will not use or share your information with anyone except as
            described in this Privacy Policy.
          </span>
        </p>
        <p>
          <span style={styleSpan}>
            The terms used in this Privacy Policy have the same meanings as in
            our Terms and Conditions, which is accessible at Samoa Travel Tracer
            unless otherwise defined in this Privacy Policy.
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Information Collection and Use</strong>
        </p>
        <ul>
          <li>
            <span>
              Minimal personal data is collected. When the app is users will be
              asked to register using a Samoa mobile number. This mobile number
              is the only personal data that the Ministry of Health will collect
              from the user, and it is stored in a secured server together with
              a random anonymised User ID that is linked to one’s mobile number.
              The mobile number is what allows individuals to be contacted, so
              that he may receive the appropriate guidance and care.
            </span>
          </li>
          <li>
            <span>
              Samoa Travel Tracer does not collect location data. Any usage of
              location service is purely for the function of Bluetooth tracing
              on Android devices.
            </span>
          </li>
          <li>
            <span>
              A user’s identity is never revealed to other users. The app
              creates a temporary ID, generated by encrypting the User ID so
              that only the Ministry of Health can decrypt it. The temporary ID
              is changed frequently, making it difficult to spoof. When the app
              is running, it regularly scans for nearby Samoa Travel Tracer
              users using Bluetooth. When it is able to establish a Bluetooth
              connection with such nearby users, using what we call the
              BlueTrace protocol, the app will record the temporary ID of the
              nearby phone, together with information about the phone’s model,
              Bluetooth signal strength, and time. The phone therefore never
              records any personal identifiable information. Furthermore, all
              this information is stored on the phone, andis never uploaded to
              the Ministry of Health or shared with anyone else, unless
              explicitly authorised and initiated by the user.
            </span>
          </li>
          <li>
            <span>
              Records will only be uploaded during contact tracing. In a Samoa
              Travel Tracer user is contacted by the contact tracer, he/she will
              be asked to upload the proximity history stored in the Samoa
              Travel Tracer app to the Ministry of Health. We have put in place
              an authentication mechanism to ensure that only a genuine contact
              tracer can request a user to upload his/her data
            </span>
          </li>
          <li>
            <span>
              Samoa Travel Tracer is implemented using BlueTrace protocol. More
              information on the BlueTrace protocol and coalition can be found
              at{' '}
              <a
                href="https://bluetrace.io"
                rel="noopener noreferrer"
                target="_blank"
                style={styleATag}
              >
                https://bluetrace.io
              </a>
              .
            </span>
          </li>
        </ul>
        <p>
          <span style={styleSpan}>
            The app does use third party services that may collect information
            used to identify you.
          </span>
        </p>
        <p>
          <span style={styleSpan}>
            Link to privacy policy of third party service providers used by the
            app
          </span>
        </p>
        <ul>
          <li>
            <a
              href="https://www.google.com/policies/privacy/"
              rel="noopener noreferrer"
              target="_blank"
              style={styleATag}
            >
              Google Play Services
            </a>
          </li>
          <li>
            <a
              href="https://firebase.google.com/policies/analytics"
              rel="noopener noreferrer"
              target="_blank"
              style={styleATag}
            >
              Google Analytics for Firebase
            </a>
          </li>
        </ul>
        <p>
          <strong style={styleStrong}>Log Data</strong>
        </p>
        <p>
          <span style={styleSpan}>
            We want to inform you that whenever you use our Service, in a case
            of an error in the app we collect data and information (through
            third party products) on your phone called Log Data. This Log Data
            may include information such as your device Internet Protocol (“IP”)
            address, device name, operating system version, the configuration of
            the app when utilizing our Service, the time and date of your use of
            the Service, and other statistics.
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Cookies</strong>
        </p>
        <p>
          <span style={styleSpan}>
            Cookies are files with a small amount of data that are commonly used
            as anonymous unique identifiers. These are sent to your browser from
            the websites that you visit and are stored on your device's internal
            memory.
          </span>
        </p>
        <p>
          <span style={styleSpan}>
            This Service does not use these “cookies” explicitly. However, the
            app may use third party code and libraries that use “cookies” to
            collect information and improve their services. You have the option
            to either accept or refuse these cookies and know when a cookie is
            being sent to your device. If you choose to refuse our cookies, you
            may not be able to use some portions of this Service.
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Service Providers</strong>
        </p>
        <p>
          <span style={styleSpan}>
            We may employ third-party companies and individuals due to the
            following reasons:
          </span>
        </p>
        <ul>
          <li>
            <span>To facilitate our Service;</span>
          </li>
          <li>
            <span>To provide the Service on our behalf;</span>
          </li>
          <li>
            <span>To perform Service-related services; or</span>
          </li>
        </ul>
        <p>
          <span style={styleSpan}>
            We want to inform users of this Service that these third parties
            have access to your Personal Information. The reason is to perform
            the tasks assigned to them on our behalf. However, they are
            obligated not to disclose or use the information for any other
            purpose.
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Security</strong>
        </p>
        <p>
          <span style={styleSpan}>
            We value your trust in providing us your Personal Information, thus
            we are striving to use commercially acceptable means of protecting
            it. But remember that no method of transmission over the internet,
            or method of electronic storage is 100% secure and reliable, and we
            cannot guarantee its absolute security.
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Links to Other Sites</strong>
        </p>
        <p>
          <span style={styleSpan}>
            This Service may contain links to other sites. If you click on a
            third-party link, you will be directed to that site. Note that these
            external sites are not operated by us. Therefore, we strongly advise
            you to review the Privacy Policy of these websites. We have no
            control over and assume no responsibility for the content, privacy
            policies, or practices of any third-party sites or services.
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Children’s Privacy</strong>
        </p>
        <p>
          <span style={styleSpan}>
            These Services do not address anyone under the age of 13. We do not
            knowingly collect personally identifiable information from children
            under 13 years of age. In the case we discover that a child under 13
            has provided us with personal information, we immediately delete
            this from our servers. If you are a parent or guardian and you are
            aware that your child has provided us with personal information,
            please contact us so that we will be able to do necessary actions.
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Changes to This Privacy Policy</strong>
        </p>
        <p>
          <span style={styleSpan}>
            We may update our Privacy Policy from time to time. Thus, you are
            advised to review this page periodically for any changes. We will
            notify you of any changes by posting the new Privacy Policy on this
            page.
          </span>
        </p>
        <p>
          <span style={styleSpan}>
            This policy is effective as of 2021-05-25
          </span>
        </p>
        <p>
          <strong style={styleStrong}>Contact Us</strong>
        </p>
        <p>
          <span style={styleSpan}>
            If you have any questions or suggestions about our Privacy Policy,
            do not hesitate to contact us at info@skyeyepacific.com
          </span>
        </p>
      </div>
    </div>
  );
}

PolicyPage.propTypes = {};

export default PolicyPage;
